@if (environment.newAuthPages) {
<app-auth-shell mode="signup">
  @if (registered) {
    <h1 class="auth-title">Sign up</h1>
    <p class="auth-subtitle">Check your email to confirm your registration.</p>
    <div class="auth-row">
      <button type="button" class="auth-btn" (click)='tryAgain()'>Try Again</button>
      <button type="button" class="auth-btn auth-btn-secondary" [routerLink]="'/'">Back</button>
      <button type="button" class="auth-btn auth-btn-secondary" [routerLink]="'/signin'">Sign In</button>
    </div>
  } @else {
  <form [formGroup]="form" (ngSubmit)="register()" class="auth-form">
    <h1 class="auth-title">Sign up</h1>
    @if (!invited) {
      <p class="auth-subtitle">Sign up for a free trial of barxui.</p>
    } @else {
      <p class="auth-subtitle">Enter a password to create your login and accept the invitation to {{orgName}}.</p>
    }

    <div class="auth-field">
      <label for="signup-email">Email</label>
      <input data-cy="email" class="auth-input" id="signup-email" type="email" formControlName="email" required
        maxlength="100">
      @if (form.get('email')?.touched && form.get('email')?.hasError('required')) {
        <div class="auth-field-error">An email address is required.</div>
      }
      @if (form.get('email')?.touched && form.get('email')?.hasError('email')) {
        <div class="auth-field-error">Not a valid email.</div>
      }
    </div>

    <div class="auth-field">
      <label for="signup-password">Password</label>
      <input data-cy="password" class="auth-input" id="signup-password" type="password" formControlName="password"
        required pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,100}" autocomplete="new-password">
      @if (form?.controls.password.invalid && form?.controls.password.touched) {
        @if (form?.controls.password.errors?.required) {
          <div class="auth-field-error">Password is required.</div>
        }
        @if (form?.controls.password.errors?.pattern) {
          <div class="auth-field-error">Must contain at least one number and one uppercase and lowercase letter,
            and at least 8 to 100 characters.</div>
        }
      }
    </div>

    <div class="auth-field">
      <label for="signup-confirmpassword">Confirm Password</label>
      <input data-cy="confirmpassword" class="auth-input" id="signup-confirmpassword" type="password"
        formControlName="confirmpassword" required autocomplete="new-password">
      @if (form?.controls.confirmpassword.touched) {
        @if (form?.controls.confirmpassword.errors?.required) {
          <div class="auth-field-error">Confirm password is required.</div>
        }
        @if (form?.errors?.passwordMismatch) {
          <div class="auth-field-error">Password &amp; Confirm Password do not match and must contain at least 8 to
            100 characters.</div>
        }
      }
    </div>

    @if (!invited) {
      <div class="auth-field">
        <label for="signup-orgname">Organisation Name</label>
        <input data-cy="orgname" class="auth-input" id="signup-orgname" type="text" formControlName="orgname"
          maxlength="200" placeholder="Optional">
      </div>
    }

    @if (!invited) {
      <div class="auth-field">
        <label for="signup-invitecode">Invite Code</label>
        <input data-cy="invitecode" class="auth-input" id="signup-invitecode" type="text"
          formControlName="inviteCode" autocomplete="off" placeholder="Optional, from your barxui Partner">
        @if (form?.controls.inviteCode.invalid && form?.controls.inviteCode.touched) {
          @if (form?.controls.inviteCode.errors?.required) {
            <div class="auth-field-error">Invite Code is required.</div>
          }
          @if (form?.controls.inviteCode.errors?.invalid) {
            <div class="auth-field-error">Invite Code is invalid.</div>
          }
        }
      </div>
    }

    @if (busy) {
      <simple-progress message='Registering'></simple-progress>
    } @else {
      <button data-cy="signup-button" type="submit" class="auth-btn auth-btn-block" [disabled]="!form.valid">Sign up</button>
    }

    @if (!!error) {
      <app-warning-panel [error]='true'>{{error}}</app-warning-panel>
    }
  </form>
  }
</app-auth-shell>
} @else {
<style>
  .main {
    margin-top: 10em;
  }
</style>
<app-bganimation tagName="body" className="warehouse"></app-bganimation>
<div class="main wider layout-row layout-align-center layout-justify-center">
  <form [formGroup]="form" (ngSubmit)="register()">
    <mat-card>
      <mat-card-header>
        <mat-card-title>Sign Up</mat-card-title>
        @if (!invited) {
        <mat-card-subtitle>Sign Up for a free trial of barxui.</mat-card-subtitle>
        }
      </mat-card-header>
      <mat-card-content>
        @if (registered) {
        <div>
          <p>Check your email to confirm your registeration.</p>
        </div>
        } @else {
        <div class="layout-row-gap-1 layout-align-start">
          <div class="layout-col-gap-1">
            @if (invited) {
            <div>
              Enter a password to create your login and accept the invitation to {{orgName}}.
            </div>
            }
            <!-- <mat-form-field>
              <mat-label>Name</mat-label>
              <input type="text" matInput formControlName="name" required placeholder="Name">
              <mat-error>A name is required and it must have from 3 to 200 characters.</mat-error>
            </mat-form-field> -->
            <mat-form-field class="wide">
              <mat-label>Email</mat-label>
              <input data-cy="email" type="email" matInput formControlName="email" required maxlength="100">
              @if (form.get('email').hasError('required')) {
              <mat-error>An email address is required.</mat-error>
              }
              @if (form.get('email').hasError('email')) {
              <mat-error>Not a valid email.</mat-error>
              }
            </mat-form-field>
            <mat-form-field class="wide">
              <mat-label>Password</mat-label>
              <input data-cy="password" type="password" matInput formControlName="password" maxlength=""
                class="form-control" required pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,100}"
                autocomplete="new-password" />
              @if (form?.controls.password.invalid && form?.controls.password.touched) {
              <div>
                @if (form?.controls.password.errors.required) {
                <mat-error> Password is required. </mat-error>
                }
                @if (form?.controls.password.errors.pattern) {
                <mat-error> Must contain at least one number and one
                  uppercase and
                  lowercase
                  letter,
                  and at least 8 to 100 characters.</mat-error>
                }
              </div>
              }
            </mat-form-field>
            <mat-form-field class="wide">
              <mat-label>Confirm Password</mat-label>
              <input data-cy="confirmpassword" type="password" matInput formControlName="confirmpassword" required
                autocomplete="new-password" />
              @if (form?.controls.confirmpassword.touched) {
              <div>
                @if (form?.controls.confirmpassword.errors?.required) {
                <mat-error> Confirm password is required.
                </mat-error>
                }
                @if (form?.errors?.passwordMismatch) {
                <mat-error> Password & Confirm Password do not match and must contain at least 8 to 100
                  characters.</mat-error>
                }
              </div>
              }
            </mat-form-field>
            @if (!invited) {
            <mat-form-field class="wide">
              <mat-label>Organisation Name</mat-label>
              <input data-cy="orgname" type="text" matInput formControlName="orgname" maxlength="200">
              <mat-hint>Optional Organisation Name.</mat-hint>
            </mat-form-field>
            }
            @if (!invited) {
            <mat-form-field class="wide">
              <mat-label>Invite Code</mat-label>
              <input data-cy="invitecode" type="text" matInput formControlName="inviteCode" autocomplete="off" />
              <mat-hint>Optional Invite Code from your barxui Partner.</mat-hint>
              @if (form?.controls.inviteCode.invalid && form?.controls.inviteCode.touched) {
              <div>
                @if (form?.controls.inviteCode.errors.required) {
                <mat-error> Invite Code is required.
                </mat-error>
                }
                @if (form?.controls.inviteCode.errors.invalid) {
                <mat-error> Invite Code is invalid.
                </mat-error>
                }
              </div>
              }
            </mat-form-field>
            }
            <!-- <mat-form-field>
            <mat-label>Phone</mat-label>
            <input type="text" matInput formControlName="phone" placeholder="Phone">
          </mat-form-field> -->
          </div>
        </div>
        }
      </mat-card-content>
      <mat-card-actions>
        <div class="layout-col-gap-05">
          @if (registered) {
          <div>
            <button mat-raised-button color="primary" (click)='tryAgain()'>Try Again</button>
            <button mat-stroked-button [routerLink]="'/'">Back</button>
            <button mat-stroked-button [routerLink]="'/signin'">Sign In</button>
          </div>
          } @else {
          <div>
            @if (busy) {
            <simple-progress message='Registering'></simple-progress>
            } @else {
            <button data-cy="signup-button" mat-raised-button type="submit" color="primary"
              [disabled]="!form.valid">Sign Up</button>
            <!-- <button mat-stroked-button [routerLink]="'/signin'">Sign In</button> -->
            }
            <ng-template #controls>
              <button data-cy="signup-button" mat-raised-button type="submit" color="primary"
                [disabled]="!form.valid">Sign Up</button>
              <!-- <button mat-stroked-button [routerLink]="'/signin'">Sign In</button> -->
            </ng-template>
          </div>
          <div>
            @if (!!error) {
            <app-warning-panel [error]='true'>{{error}}</app-warning-panel>
            }
          </div>
          }
        </div>
      </mat-card-actions>
    </mat-card>
  </form>
</div>
}
